import React, { useState } from 'react';
import PasswordReset from './PasswordReset';
// import Alert from 'react-s-alert';
import { loginAPI } from '../APIUtils';
import { getLastPath, saveAuthentication, saveUserInfo, userInfo } from '../CookiesUtil';
import { useAppNavigation } from '../historyUtils';
import { useDispatch } from "react-redux";
import { login } from "src/store/reducers/authSlice";

interface LoginEmailFormProps {
    onLogin: (userData: { email: string; name: string }) => void;
}

const LoginEmailForm: React.FC<LoginEmailFormProps> = ({ onLogin }) => {
    const navigate = useAppNavigation();
    const dispatch = useDispatch();
    
    const [myUser, setMyUser] = useState({
        email: '',
        password: '',
    });
    const [displayReset, setDisplayReset] = useState(false);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setMyUser({
            ...myUser,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();

        try {
            const response = await loginAPI(myUser);
            console.log("response userPrincipal :", response.userPrincipal);
            console.log("response accessToken :", response.accessToken);

            saveAuthentication(response.accessToken);
            // Alert.success("You're successfully logged in!");

            const user = response.userPrincipal;
            if (user) {
                saveUserInfo(user);
                dispatch(login(userInfo()));
                onLogin(user);

                const redirectPath = getLastPath() || "/restaurant/boss";
                navigate(redirectPath);
            }
        } catch (error) {
            // Alert.error("Invalid credentials or account issue.");
        }
    };

    return (
        <div className="mt-6">
            {displayReset ? (
                <PasswordReset />
            ) : (
                <div>
                    <h1 className="text-2xl font-bold italic text-blue-600">Login with Email</h1>
                    <form onSubmit={handleSubmit} className="mt-4">
                        <div className="mb-4">
                            <input
                                type="email"
                                name="email"
                                value={myUser.email}
                                onChange={handleInputChange}
                                className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="Email"
                                required
                            />
                        </div>
                        <div className="mb-4">
                            <input
                                type="password"
                                name="password"
                                value={myUser.password}
                                onChange={handleInputChange}
                                className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="Password"
                                required
                            />
                        </div>
                        <div className="flex items-center space-x-4">
                            <button 
                                type="submit" 
                                className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500">
                                Login
                            </button>
                            <button 
                                type="button" 
                                onClick={() => setDisplayReset(true)} 
                                className="px-4 py-2 text-blue-600 border border-blue-600 rounded hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-500">
                                Reset Password
                            </button>
                        </div>
                    </form>
                </div>
            )}
        </div>
    );
};

export default LoginEmailForm;